import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { StoreErrorHandler } from '@zero/shared/util-global-state';
import { catchError, filter, map, of, switchMap, tap } from 'rxjs';
import { SepaInfrastructure } from '../../infrastructure/sepa.infrastructure';
import { sepaActions, sepaApiActions } from './sepa.actions';

@Injectable({ providedIn: 'root' })
export class SepaEffects {
  readonly #actions = inject(Actions);
  readonly #sepaInfrastructure = inject(SepaInfrastructure);
  readonly #storeErrorHandler = inject(StoreErrorHandler);

  public loadHasSepa$ = createEffect(() => {
    return this.#actions.pipe(
      ofType(sepaActions.loadHasSepa),
      switchMap(() =>
        this.#sepaInfrastructure.getSepa().pipe(
          map((hasSepa) => sepaApiActions.loadHasSepaSuccess({ hasSepa })),
          catchError((error) => of(sepaApiActions.loadHasSepaFailure({ error }))),
        ),
      ),
    );
  });

  public loadHasSepaSuccess$ = createEffect(() => {
    return this.#actions.pipe(
      ofType(sepaApiActions.loadHasSepaSuccess),
      map(() => sepaActions.loadOptions()),
    );
  });

  public displaySuccessHint$ = createEffect(() => {
    return this.#actions.pipe(
      ofType(sepaApiActions.toggleSepaSuccess),
      filter(({ response }) => response.useDirectDebit),
      map(() => sepaActions.displaySuccessHint()),
    );
  });

  public toggleSepa$ = createEffect(() => {
    return this.#actions.pipe(
      ofType(sepaActions.toggleSepa),
      switchMap(({ useDirectDebit }) =>
        this.#sepaInfrastructure.toggleSepa(useDirectDebit).pipe(
          map((response) => sepaApiActions.toggleSepaSuccess({ response })),
          catchError((error) => of(sepaApiActions.toggleSepaFailure({ error }))),
        ),
      ),
    );
  });

  public resetOptions$ = createEffect(() => {
    return this.#actions.pipe(
      ofType(sepaActions.resetOptions),
      map(() => sepaActions.loadOptions()),
    );
  });

  public handleBackendErrors$ = createEffect(
    () => {
      return this.#actions.pipe(
        ofType(sepaApiActions.loadHasSepaFailure, sepaApiActions.toggleSepaFailure),
        tap((error) => this.#storeErrorHandler.handleBackendError(error)),
      );
    },
    { dispatch: false },
  );
}
